import { render, staticRenderFns } from "./Newrecruitment.vue?vue&type=template&id=0c9760c3"
import script from "./Newrecruitment.vue?vue&type=script&lang=js"
export * from "./Newrecruitment.vue?vue&type=script&lang=js"
import style0 from "./Newrecruitment.vue?vue&type=style&index=0&id=0c9760c3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports